export const getUserFullName = (user: {
  firstName?: string;
  lastName?: string;
}) =>
  `${user.firstName ? user.firstName : ''} ${
    user.lastName ? user.lastName : ''
  }`;
